import { CreditBudgetDialogInner } from "./CreditBudgetDialogInner";

import { ClientType } from "@/types/client/ClientType";

interface CreditBudgetDialogProps {
  clientId: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSuccess: () => void;
  onCancel: () => void;
  client?: ClientType;
}

export const CreditBudgetDialog = ({
  open,
  onOpenChange,
  onSuccess,
  onCancel,
  ...props
}: CreditBudgetDialogProps) => {
  const handleOpenChange = (newOpen: boolean) => {
    onOpenChange(newOpen);
    if (!newOpen) {
      onCancel();
    }
  };

  const handleSuccess = () => {
    onSuccess();
  };

  return (
    <CreditBudgetDialogInner
      {...props}
      open={open}
      onOpenChange={handleOpenChange}
      onSuccess={handleSuccess}
    />
  );
};
